'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fade = require('../../internal/fade');

var _fade2 = _interopRequireDefault(_fade);

var _colors = require('../../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  root: {
    color: 'currentColor',
    fontSize: '12px',
    lineHeight: '12px',
    textAlign: 'right',
    padding: '0 0 0 10px',
    opacity: '.75'
  },
  edited: {
    marginRight: '4px'
  },
  image: {
    padding: '4px',
    borderRadius: '4px 0 4px',
    backgroundColor: (0, _fade2.default)(_colors2.default.black, 0.55),
    position: 'absolute',
    bottom: '12px',
    right: '12px',
    color: _colors2.default.white,
    opacity: 1
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/message/message-time/styles.js
// module id = 300
// module chunks = 0